import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'hdw-about-hiv-tool',
  templateUrl: './about-hiv-tool.component.html',
  styleUrls: ['./about-hiv-tool.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AboutHivToolComponent {}
